import { navigate } from "gatsby"
import {
    Card,
    componentStyles,
    Modal,
    SIZES,
    TextBold,
    TextNote,
    VerticalStackStretch,
} from "@mallardbay/lib-react-components"
import React from "react"

import usePersistedWidgetCheckoutParamsString from "~utils/use-persisted-widget-checkout-params-string"
import COPY from "~config/copy-constants"

interface Props {
    readonly listingId?: string | null | undefined
}

export default function RestoreCheckoutSessionModal({ listingId }: Props) {
    const styles = useStyles()

    const { checkoutParamsString, clearCheckoutParamsString } =
        usePersistedWidgetCheckoutParamsString(listingId)

    const optionConfigs = useOptionConfigs({
        checkoutParamsString,
        clearCheckoutParamsString,
    })

    return (
        <Modal
            title={COPY.RESTORE_SESSION_MODAL.TITLE}
            isOpen={Boolean(checkoutParamsString)}
            onClose={clearCheckoutParamsString}
            size={SIZES.MD}
            shouldAddPadding
        >
            <VerticalStackStretch>
                {optionConfigs.map(({ title, description, onClick }) => (
                    <Card key={title} style={styles.card} onClick={onClick}>
                        <TextBold>{title}</TextBold>
                        <TextNote style={styles.note}>{description}</TextNote>
                    </Card>
                ))}
            </VerticalStackStretch>
        </Modal>
    )
}

function useStyles() {
    return componentStyles({
        card: { cursor: "pointer", backgroundColor: "none" },
        note: { marginTop: 2 },
    })
}

function useOptionConfigs({
    checkoutParamsString,
    clearCheckoutParamsString,
}: {
    checkoutParamsString: string | null
    clearCheckoutParamsString: () => void
}) {
    return [
        {
            title: COPY.RESTORE_SESSION_MODAL.RESTORE_OPTION_TITLE,
            description: COPY.RESTORE_SESSION_MODAL.RESTORE_OPTION_DESCRIPTION,
            onClick: () => {
                if (!checkoutParamsString) return

                void navigate(checkoutParamsString)
            },
        },
        {
            title: COPY.RESTORE_SESSION_MODAL.FRESH_OPTION_TITLE,
            description: COPY.RESTORE_SESSION_MODAL.FRESH_OPTION_DESCRIPTION,
            onClick: clearCheckoutParamsString,
        },
    ]
}
